// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"41720f33","977":"ba92360d"}[chunkId] + ".chunk.js";
};